import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from 'react-router-dom';
import { useSignup } from "../../../Hooks/Auth/useSignup";
import BackgroundCarousel from "../../../layout/BackgroundCarousel";
import "../Login/login.css"


const ForgotPassword = () => {
    const location = useLocation().state
    const { signupdata, setsignupdata, error, handleSubmit, setError, handleValidation, captcha, setcaptcha, imageSrc, imageRef, fetchCaptcha } = useSignup();
    return (
        <>
            {/* <div
                style={{ position: "fixed", top: 18, left: 22, zIndex: 9999 }}>
                <img src="./assets/logo-white-1.png" alt="Logo" style={{ height: 55 }} />
            </div> */}
            <BackgroundCarousel />
            <form onSubmit={handleSubmit} className="login-form" style={{ top: "25%" }}>
                <h3 className="login-text ">Forgot Password</h3>
                <div className="input-set my-2 mx-0">
                    <label>Employee Code/E-mail</label>
                    <input
                        onBlur={(e) => handleValidation('sign_up', e.target.value, setError)}
                        value={signupdata}
                        onChange={(e) => { setsignupdata(e.target.value); setError((prevState) => ({ ...prevState, user_loginname: '' })); }}
                        placeholder="Employee Code/E-mail"
                        name="signupdata"
                        className="mx-0 w100"
                    />
                    {error?.user_loginname && (
                        <p className="text-danger text-left font-weight-bold mx-2">
                            {error?.user_loginname}
                        </p>
                    )}
                </div>

                <div className="input-set my-2 mx-0">
                    <label>Enter CAPTCHA</label>
                    <input
                        placeholder="Enter CAPTCHA"
                        width='100'
                        value={captcha.captchaCode}
                        onChange={(e) => {
                            setcaptcha((prevState) => ({ ...prevState, captchaCode: e.target.value }))
                            setError((prevState) => ({ ...prevState, captcha: '' }))
                        }}
                        fullWidth
                        className="w100 mx-0"
                    />
                    {error?.captcha && (
                        <p className="text-danger text-left font-weight-bold mx-2">
                            {error?.captcha}
                        </p>
                    )}
                </div>
                <div className="captcha-container mt-2" >
                    <div className="captcha-display">
                        <div>
                            {imageSrc ? (
                                <img id="output" ref={imageRef} alt="output" style={{ height: "45px" }} />
                            ) : (
                                <p>Loading image...</p>
                            )}
                        </div>
                    </div>
                    <div style={{ cursor: 'pointer' }} onClick={() => {
                        fetchCaptcha()
                        setcaptcha({
                            captchaCode: '',
                            captchaId: ""
                        })
                    }}><FontAwesomeIcon icon="fa fa-refresh" /></div>
                </div>
                {error?.apiError && (
                    <p className="text-danger text-left font-weight-bold mx-2">
                        {error?.apiError}
                    </p>
                )}
                <Button type="submit" variant="contained" className="login-button mt-3" >
                    {location?.key === "is_forgot" ? "Forgot Passsword" : "Sign Up"}
                </Button>
                <div className="text-black text-center">
                    {location?.key !== "is_forgot" ?
                        <p>
                            Already have an account?{" "}
                            <Link
                                to="/sign-in"
                                className="text-black"
                                style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                }}
                            >
                                Sign In
                            </Link>
                        </p> : <p>Back to <Link className="sign-in text-black" to="/sign-in" > Sign In</Link></p>}
                </div>
            </form>
        </>
    );
};

export default ForgotPassword;
